export const SourcesOfFunds = {
  businessActivity: 'Від господарської діяльності',
  financialAssistance: 'У вигляді фінансової допомоги',
  contractAndDerivatives:
    'Надходження від укладання строкових контрактів або використання інших похідних фінансових інструментів та деривативів',
  loan: 'У вигляді позики',
  saleOfReceivables: 'Продаж/відступлення права грошової вимоги',
  saleOfSecurities: 'Продаж цінних паперів',
  other: (text: string) => `Інше (зазначте): ${text}`,
};

export const EMPTY_BANK_ACCOUNTS = {
  accountNumber: null,
  bankName: null,
  bankMFO: null,
  currency: null,
};

export const bankAccountsTableColumns = [
  {
    title: 'Номер рахунку',
    size: 4,
  },
  {
    title: 'Найменування банку',
    size: 3,
  },
  {
    title: 'МФО банку',
    size: 2,
  },
  {
    title: 'Валюта',
    size: 2,
  },
  {
    title: 'Дії',
    size: 1,
  },
];

export const titleFinancialCondition = {
  fop: 'Додаткова інформація щодо фінансового стану, станом на',
  legal: 'Додаткова інформація щодо фінансового стану клієнта, станом на',
};

export const testDataFinancialCondition = {
  noOtherBankAccounts: true,
  bankAccounts: [],
  prevDate: null,
  securitiesNominalValue: 1,
  netIncomeFromSales: 25794193,
  totalLoanDebt: 1,
  debtFromNonResidentLoans: 1,
  costOfGoodsSold: 10345210,
  grossProfitOrLoss: '5739999.0',
  nonCurrentAssets: 35472354,
  totalDeposits: 1,
  currentAssets: 11556590,
  currentLiabilities: '9758576.0',
  equity: 14123235,
  salesExpenses: '2842606.0',
  plannedMonthlyInflows: 1,
  maxMonthlyInflows: 1,
  prevYearTaxableIncome: 3356,
  fundingSources: {
    businessActivity: false,
    financialAssistance: true,
    contractAndDerivatives: false,
    loan: true,
    saleOfReceivables: true,
    saleOfSecurities: false,
    other: null,
  },
};
